import { StyleSheet } from 'react-native';

export const globalLayeredAvatarModalStyles = StyleSheet.create({
  content: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  inner: {
    flex: 1,
    width: '100%',
    // Full-screen: the customizer fills tablet/desktop instead of a centered phone
    // column. The shop grid scales its column count with width (columnsForWidth) so
    // cells stay phone-sized rather than stretching sparse.
    height: '100%',
  },
});
